import { Injectable } from "@angular/core";
@Injectable()
export class IdentityVerificationStatusModel{
    Pending = 'Pending';
    Completed = <any> 'Completed';
    Unverified = <any> 'Unverified';
    MoreInfoRequired = <any> 'MoreInfoRequired';
}